<template>
  <div class="maintenance-item">
    <div class="maintenance-box">
      <div class="item-title">{{ $t('asm_maintenance_item.bao_yang_xiang_mu') }}</div>
      <div class="item-list">
        <el-collapse v-model="componentCode" accordion>
          <el-collapse-item v-for="item in componentList" :key="item.componentCode" :title="item.componentName" :name="item.componentCode">
            <div class="part-pic ub">
              <div style="margin-right: 60px" v-if="item.beforeimg && item.beforeimg.length">
                <h1>{{ $t('asm_maintenance_item.byqtp') }}</h1>
                <ul class="ubw">
                  <li v-for="(item, index) in item.beforeimg" :key="index">
                    <img :src="item" alt />
                  </li>
                </ul>
              </div>
              <div v-if="item.afterimg && item.afterimg.length">
                <h1>{{ $t('asm_maintenance_item.bao_yang_hou_tu_pian') }}</h1>
                <ul class="ubw">
                  <li v-for="(item, index) in item.afterimg" :key="index">
                    <img :src="item" alt />
                  </li>
                </ul>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>

    <div class="examination-box">
      <div class="item-title">{{ $t('asm_maintenance_item.jian_cha_xiang_mu') }}</div>
      <div class="item-list">
        <el-collapse v-model="itemId" accordion>
          <el-collapse-item v-for="item in itemList" :key="item.itemId" :title="item.itemName" :name="item.itemId">
            <template slot="title">
              {{ item.itemName }}
              <span class="state" v-if="item.isChecked">{{ $t('asm_maintenance_item.yi_bao_yang') }}</span>
              <span class="state" v-else>{{ $t('asm_maintenance_item.dai_bao_yang') }}</span>
            </template>
            <p>{{ $t('asm_maintenance_item.bao_yang_zhi_yin') }}</p>
            <div class="part-pic ub">
              <div style="margin-right: 60px" v-if="item.attachPath && item.attachPath.length">
                <ul class="ubw">
                  <li v-for="(pitem, index) in item.attachPath" :key="index">
                    <!-- <img :src="item" alt /> -->
                    <img v-if="pitem" :src="pitem" :key="pitem" />
                  </li>
                </ul>
              </div>
            </div>
            <div class="file-list">
              <file-list-download v-if="item.itemId" :bizId="item.itemId" bizType="asm.service.item.atlas"></file-list-download>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import fileListDownload from '@/components/deviceComponentDetailDrawer/fileListDownload.vue';

export default {
  name: '',
  mixins: [],
  components: { fileListDownload },
  props: {
    orderDeviceId: [Number, String],
    orderTechnicianId: [Number, String],
    workOrderId: [Number, String],
    caseOrderId: [Number, String],
  },
  data() {
    return {
      tableCode: 'maintenance_item',
      componentList: [],
      componentCode: '',
      itemList: [],
      itemId: '',
      // componentCode: '',
      totalRows: null,
    };
  },
  computed: {},
  watch: {
    orderDeviceId: {
      immediate: true,
      handler(val) {
        if (val && this.orderTechnicianId) {
          this.getComponentList();
        }
      },
    },
    // orderTechnicianId: {
    //   immediate: true,
    //   handler(val) {
    //     if (val && this.orderDeviceId) {
    //       this.getComponentList();
    //     }
    //   },
    // },
    workOrderId: {
      immediate: true,
      handler(val) {
        if (val) {
          this.getItemList();
        }
      },
    },
  },
  methods: {
    getComponentList() {
      this.$getJSON(apis.workOrderUpkeepResultComponentList, {
        orderDeviceId: this.orderDeviceId,
        orderTechnicianId: this.orderTechnicianId,
      }).then((res) => {
        const list = res.data || [];
        if (list) {
          this.formatAttachList(list, 'upkeepResultId', 'asm.maintenance.before', 'beforeimg', 'Array').then(result => this.formatAttachList(result, 'upkeepResultId', 'asm.maintenance.after', 'afterimg', 'Array')).then((result) => {
            this.componentList = result || [];
          });
        }
      });
    },
    getItemList() {
      if (this.workOrderId) {
        // 工单
        this.$getJSON(apis.workOrderItemList, {
          workOrderId: this.workOrderId,
          // workOrderId: '551587061861699590',
        }).then((res) => {
          const list = res.data || [];
          // 406893277316755456，551465781011402752，563770276638609408，560551166379282432
          if (list) {
            this.formatAttachList(list, 'itemId', 'asm.service.item.icon', 'attachPath', 'Array').then((result) => {
              this.itemList = result || [];
            });
          }

        });
      } else {
        // 案例
        this.$getJSON(apis.caseOrderItemList, {
          caseOrderId: this.caseOrderId,
          // workOrderId: '551587061861699590',
        }).then((res) => {
          const list = res.data || [];
          if (list) {
            this.formatAttachList(list, 'itemId', 'asm.service.item.icon', 'attachPath', 'Array').then((result) => {
              this.itemList = result || [];
            });
          }

        });
      }
    },
  },
  created() {},
  mounted() {
  },
};
</script>

<style lang="scss">
.maintenance-item {
  padding: 16px;
  display: flex;
  // flex-direction: column;
  height: 100%;
  .maintenance-box,
  .examination-box {
    flex: 1;
    overflow-y: auto;
    padding: 0 10px;
    display: flex;
    flex-direction: column;
    .item-list {
      flex: 1;
      overflow-y: auto;
    }
    .el-collapse-item__header {
      position: relative;
      .state {
        position: absolute;
        right: 20px;
        top: 50%; /*偏移*/
        transform: translateY(-50%);
      }
    }
  }
  .part-pic {
    padding: 16px;
    h1 {
      font-weight: bold;
      line-height: 17px;
      margin-bottom: 10px;

      font-size: 12px;
      color: #495057;
      line-height: 17px;
    }
    ul li img {
      width: 60px;
      height: 60px;
      border-radius: 2px;
      // border: 1px solid rgba(238, 238, 238, 1);
      margin-right: 16px;
    }
  }
}
</style>
